module.exports = __webpack_public_path__ + "static/media/wx_qun.1c6fe7cc.jpeg";